/** How long a returning visitor stays identified in GA4, Meta and TikTok, matching Customer.io's identity cookie */
const IDENTIFIED_USER_MAX_AGE_MS = 365 * 24 * 60 * 60 * 1000

const META_CLICK_ID_QUERY_PARAM = 'fbclid'

const META_CLICK_ID_COOKIE = '_fbc'
const META_BROWSER_ID_COOKIE = '_fbp'

const META_CLICK_ID_MAX_AGE_SECONDS = 90 * 24 * 60 * 60

const META_CLICK_ID_COOKIE_PATTERN = /^fb\.\d+\.\d+\.(.+)$/

const META_CLICK_ID_PATTERN = /^[\w.-]{1,512}$/

/**
 * GA4 event parameter carrying the phone hash to the server-side GTM container, which passes it on to Meta's
 * Conversions API as x-fb-ud-ph and keeps it out of GA4. Google's own sha256_phone_number keeps the + that Meta
 * hashes without, so the two can't share a field.
 */
const META_HASHED_PHONE_PARAMETER = 'meta_hashed_phone'

const LOCALES_DEFAULT_CONSENT = {
  default: {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
  },
}

export {
  IDENTIFIED_USER_MAX_AGE_MS,
  META_BROWSER_ID_COOKIE,
  META_CLICK_ID_COOKIE,
  META_CLICK_ID_COOKIE_PATTERN,
  META_CLICK_ID_MAX_AGE_SECONDS,
  META_CLICK_ID_PATTERN,
  META_CLICK_ID_QUERY_PARAM,
  META_HASHED_PHONE_PARAMETER,
  LOCALES_DEFAULT_CONSENT,
}
